import { withStyles } from '@material-ui/core';

import TagsForm from './component';
import styles from './styles';

export default withStyles(styles)(TagsForm);
